import { UTCDate } from '@date-fns/utc';
import { addDays, format } from 'date-fns';
import type { RequestDirectDealForm, RequestDirectDealPayload } from './types.ts';

export const transformFormData = (data: RequestDirectDealForm): RequestDirectDealPayload => {
  const sanitizedData = Object.entries(data).reduce((acc, [key, value]) => {
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {} as RequestDirectDealForm);

  if (sanitizedData.startDate) {
    sanitizedData.startDate = format(new Date(sanitizedData.startDate), 'yyyy-MM-dd');
  }
  if (sanitizedData.endDate) {
    sanitizedData.endDate = format(new Date(sanitizedData.endDate), 'yyyy-MM-dd');
  }

  const transformedData: RequestDirectDealPayload = {
    deal_type: sanitizedData.dealType,
    advertiser_brand: sanitizedData.advertiserBrand,
    budget: sanitizedData.budget,
    start_date: sanitizedData.startDate || undefined,
    end_date: sanitizedData.endDate || undefined,
    targeting_details: sanitizedData.targetingDetails,
  };

  return transformedData;
};

export const getDateRanges = (startDate: string | null | undefined) => {
  const minStartDate = new UTCDate();
  const minEndDate = addDays(startDate ? new UTCDate(startDate) : minStartDate, 1);

  return { minStartDate, minEndDate };
};
